import { render, staticRenderFns } from "./FetchCurrentUser.vue?vue&type=template&id=a2e6107c&scoped=true&"
import script from "./FetchCurrentUser.vue?vue&type=script&lang=js&"
export * from "./FetchCurrentUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2e6107c",
  null
  
)

export default component.exports